<template>
  <div>
    <b-row class="v-clean">
      <b-col>
        <b-row>
          <b-col>
            <v-select
              outlined
              dense
              :items="[
                { id: null, name: 'TODOS' },
                { id: 'ATIVO', name: 'ATIVO' },
                { id: 'INATIVO', name: 'INATIVO' },
              ]"
              item-text="name"
              item-value="id"
              label="RESIDENTES ATIVO/INATIVO"
              @change="getResidents"
              v-model="status_resident"
            />
          </b-col>
          <b-col>
            <v-select-default
              label="FILTRAR POR RESIDENTE"
              :items="residents"
              v-model="resident_id"
              @change="paginate"
            />
          </b-col>
          <b-col>
            <v-text-field-default
              type="date"
              label="DATA"
              v-model="date"
              @change="paginate"
            />
          </b-col>
          <b-col>
            <v-select-default
              label="FILTRAR POR USUÁRIO"
              :items="users"
              v-model="user_id"
              @change="paginate"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <v-text-field-default
              type="text"
              label="CÓDIGO NOTA FISCAL"
              v-model="nfeId"
              @input="handleInputNfeId"
            />
          </b-col>
        </b-row>
        <errors-messages :errors="errors" />
        <b-row>
          <b-col>
            <v-data-table
              :headers="headers"
              :items="items"
              dense
              :server-items-length="count"
              :options.sync="options"
              :footer-props="{
                'items-per-page-options': [25, 50, 100],
                'items-per-page-text': 'Mostrar',
              }"
              :loading="loading"
              loading-text="Carregando..."
              no-data-text="Nenhum resultado corresponde aos filtros"
              no-results-text="Nenhum resultado corresponde aos filtros"
              @update:options="paginate"
            >
              <template v-slot:[`item.entity`]="{ item }">
                <div v-if="item.entity">
                  <div v-if="item.nfeId">
                    <strong class="ml-2">{{ item.nfeId }}</strong>
                  </div>
                  <div
                    v-for="k in Object.keys(item.entity)"
                    :key="k"
                    v-show="k != 'recipient_id'"
                  >
                    <span class="text-muted">{{ item.fields[k] }}:</span>
                    <strong class="ml-2">{{ item.entity[k] }}</strong>
                  </div>
                </div>
                <div class="border-top">
                  <div v-for="(i, key) in item.items" :key="key">
                    <div class="row m-0 border-bottom">
                      <div class="col-md-4 p-0">
                        <p class="m-0">
                          <span class="text-muted">Item:</span
                          ><span class="ml-2">{{ i.name }}</span>
                        </p>
                      </div>
                      <div class="col-md-4 p-0">
                        <p class="m-0">
                          <span class="text-muted">Quantidade:</span>
                          {{ i.amount }}
                          {{ i.abbreviation ? i.abbreviation : "" }}
                        </p>
                      </div>
                      <div class="col-md-4 p-0">
                        <p class="m-0">
                          <span class="text-muted">Valor:</span>
                          {{ formatReal(i.value) }}
                        </p>
                      </div>
                      <div class="col-md-4 p-0">
                        <p class="m-0">
                          <span class="text-muted">Lote:</span>
                          {{ i.lot ? i.lot : "NÃO INFORMADO" }}
                        </p>
                      </div>
                      <div class="col-md-4 p-0">
                        <p class="m-0">
                          <span class="text-muted">Descrição:</span>
                          {{ i.description ? i.description : "NÃO INFORMADO" }}
                        </p>
                      </div>
                      <div class="col-md-4 p-0">
                        <p class="m-0">
                          <span class="text-muted">Vencimento:</span>
                          {{ i.due_date ? i.due_date : "NÃO INFORMADO" }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:[`item.user_id`]="{ item }">
                <small>{{
                  professionalClassCouncilValue(getUserById(item.user_id))
                }}</small>
              </template>
              <template v-slot:[`item.when`]="{ item }">
                <small>{{
                  item.when ? formatDate(item.when) : item.date_time
                }}</small>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <confirmation-dialog
                  v-if="permission('write', 'main_stock_reversal')"
                  :disabled="loadingExecute"
                  :loading="loadingExecute"
                  small
                  message-title="ESTORNAR?"
                  message-body="Deseja realmente estornar a movimentação?"
                  open-class="btn-delete"
                  open-left-icon="fa-history"
                  open-text="ESTORNAR"
                  @yes="execute(item)"
                />
              </template>
            </v-data-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";
import VSelectDefault from "../../../Components/VSelectDefault";
import VTextFieldDefault from "../../../Components/VTextFieldDefault";

import ConfirmationDialog from "../../../Components/ConfirmationDialog";

import {
  formatDate,
  professionalClassCouncilValue,
  formatReal,
} from "../../../../lib/format";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import permission from "../../../../lib/permission";

export default {
  name: "PurchaseSell",

  components: {
    ErrorsMessages,
    VSelectDefault,
    VTextFieldDefault,
    ConfirmationDialog,
  },

  data() {
    return {
      status_resident: "ATIVO",
      // filtros
      table: "stocked_item",
      date: "",

      users: [],
      residents: [],
      search: "",
      user_id: "",
      resident_id: "",
      nfeId: "",

      headers: [
        { text: "Informações", value: "entity", sortable: false },
        { text: "Responsável", value: "user_id", sortable: false },
        { text: "Ocorrência", value: "when" },
        { text: "", value: "actions", sortable: false },
      ],
      items: [],
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ["when"],
        sortDesc: [true],
        multiSort: true,
        mustSort: false,
      },
      count: 0,

      errors: [],
      show: false,
      loading: false,
      loadingExecute: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    formatDate,
    professionalClassCouncilValue,
    formatReal,

    handleInputNfeId() {
      let { nfeId } = this;

      if (String(nfeId).length >= 10) {
        this.paginate();
      }

      if (!nfeId) {
        this.paginate();
      }
    },

    async retrieve() {
      await this.getUsers();
      await this.getResidents();
    },

    getUserById(id) {
      for (let user of this.users) {
        if (user.id == id) {
          return {
            id: user.professional_class_council_id,
            name: user.name,
            value: user.professional_class_council_value,
            cpf: user.cpf,
            office: user.office,
          };
        }
      }

      return {
        id: null,
        name: "DEMO",
        value: null,
        cpf: null,
        office: null,
      };
    },

    async getUsers() {
      try {
        this.loading = true;

        let response = await api.get("/rest-home/users");

        let { error, errors, users } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.users = [{ id: "", name: "TODOS" }, ...users];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getResidents() {
      try {
        this.loading = true;

        let { status_resident } = this;
        let params = { status_resident };
        let response = await api.get("/rest-home/residents", { params });

        let { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = [
            { id: "", name: "TODOS" },
            { id: "rest_home", name: "EMPRESA" },
            ...residents,
          ];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async paginate() {
      try {
        this.loading = true;

        let { table, options, search, user_id, resident_id, date, nfeId } =
          this;

        let sortings = [];
        for (let i = 0; i < options.sortBy.length; i++) {
          let header = options.sortBy[i];
          let order = options.sortDesc[i] ? "desc" : "asc";
          sortings.push({ header, order });
        }

        sortings = JSON.stringify(sortings);

        let params = {
          table,
          user_id,
          resident_id,
          date,
          search,
          page: options.page,
          items_per_page: options.itemsPerPage,
          sortings,
          action: "PURCHASE",
          nfeId,
        };

        let response = await api.get(
          "/rest-home/stock/reversal/purchase/history",
          {
            params,
          }
        );
        let { error, errors, items, count } = response.data;

        if (error) {
          this.items = [];
          this.count = 0;
          this.errors = errors;
        } else {
          this.errors = [];
          this.items = items;
          this.count = count;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async execute(item) {
      try {
        this.loadingExecute = true;

        const data = { action: "PURCHASE", item };

        const response = await api.post("/rest-home/stock/reversal", data);

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.paginate();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingExecute = false;
      }
    },
  },
};
</script>
